var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-white rounded-xl flex items-center justify-center py-1",class:("bg-" + _vm.color + "-400 text-" + _vm.textSize + " text-" + _vm.textColor + "-700")},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }